import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { UserProfileEntity } from 'src/shared/model/UserProfile';
import * as CryptoJS from 'crypto-js';
import { LoginProvider } from 'src/shared/service/login.service';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import { getErrorMessageText } from '../helper';
import { finalize } from 'rxjs/operators'; // Import NgxUiLoaderService
import { DynamicModalService } from '../ui-components/dynamic-modals/dynamic-modal.service';
import { AuthService } from '@auth0/auth0-angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})
export class LoginPageComponent implements OnInit, AfterViewInit {
  userProfile: UserProfileEntity = new UserProfileEntity();
  key = CryptoJS.enc.Utf8.parse('7061737323313233');
  iv = CryptoJS.enc.Utf8.parse('7061737323313233');
  encrypted = null;
  decrypted = null;
  display = false;
  alertMessage: string;
  bgImageUrl: string;
  footerImage: string;
  products: any = [];
  showPassword: boolean;
  buildVersion: string;
  applicationVersion: string = '';
  clientDatabaseErrorMessage: string;
  showProxyLink: boolean;
  showLoginMessage: boolean;
  loginMessage: SafeHtml;
  login2faUrl = 'login2fa';
  email = '';
  accessToken = '';

  constructor(public rest: RestService,
    private loginProvider: LoginProvider,
    public authService: AuthServiceCustom,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    private dictionaryPipe: DictionaryPipe,
    private dynamicModalService: DynamicModalService,
    public authOKTA: AuthService,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    // this.authService.configurationSet$.subscribe(() => {
    //   this.update();
    //   this.checkClientDatabaseStatus();
    // });
    
    this.authService.StarClientId = environment.star_clientid;

    this.showLoginMessage = (this.authService.loginMessage != null && this.authService.loginMessage.length > 0)
    this.loginMessage = this.sanitizer.bypassSecurityTrustHtml(this.authService.loginMessage);

    this.authOKTA.isAuthenticated$.subscribe(isAuthenticated => {
      if (isAuthenticated) {
        console.log('User is authenticated');
        /* this.authOKTA.idTokenClaims$.subscribe(claims => {
        const idToken = claims?.__raw;
        console.log('ID Token:', idToken);
        this.accessToken = idToken; 
        
        this.makeLoginCall();
        });*/

        this.authOKTA.getAccessTokenSilently().subscribe(token => {

          this.accessToken = token;
          //console.log('Access Token:', this.accessToken);
          this.makeLoginCall();
        });
        this.authOKTA.user$.subscribe(user => {

          //console.log('User Info:', user);
          this.email = user.email;

          // Example: Navigate to dashboard after login

        });
      }
    });

    this.update();

    if (window.location.search.includes('code=')) {
      // Only handle redirect callback if the URL contains the necessary code query param.
      this.authOKTA.handleRedirectCallback().subscribe({
        next: (result) => {

          console.log('Redirect callback handled successfully:', result);

        },
        error: (error) => {
          console.error('Error handling redirect callback', error);
        },
      });
    }
  }

  getApplicationVersion() {
    const version = this.authService.appVersion;
    if (version) {
      this.applicationVersion = ' / AP ' + version;
    }
  }

  tryToNavigate(url: string): void {
    if (this.clientDatabaseErrorMessage) {
      this.display = true;
      this.alertMessage = this.clientDatabaseErrorMessage;
    } else {
      this.router.navigate([url]);
    }
  }

  private checkClientDatabaseStatus(): void {
    this.ngxService.start();
    this.loginProvider.checkClientDatabaseStatus().pipe(finalize(() => this.ngxService.stop())).subscribe(
      () => {
      },
      error => {
        this.clientDatabaseErrorMessage = error.error && error.error.Message;
        this.display = true;
        this.alertMessage = this.clientDatabaseErrorMessage;
      });
  }

  handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
  }

  update() {
    this.getApplicationVersion();
    this.showProxyLink = this.authService.WpProxyFlag === 'Y';
    this.buildVersion = ' DB ' + this.authService.buildVersion + this.applicationVersion;
    this.bgImageUrl = this.authService.clientBackgroundImageUrl; // to prevent ExpressionChangedAfterItHasBeenCheckedError
    this.footerImage = this.authService.clientFooterImageUrl; // to prevent ExpressionChangedAfterItHasBeenCheckedError
  }

  ngAfterViewInit() {
    this.authService.accessTokenRemovedSubj.next(true);
  }

  login() {
    if (this.clientDatabaseErrorMessage) {
      this.display = true;
      this.alertMessage = this.clientDatabaseErrorMessage;
      return;
    }

    this.authOKTA.loginWithRedirect({
      authorizationParams: {
        connection: this.authService.Auth0Connection
      }
    });

    this.ngxService.start();
  }

  loginVistra() {
    if (this.clientDatabaseErrorMessage) {
      this.display = true;
      this.alertMessage = this.clientDatabaseErrorMessage;
      return;
    }

    this.authOKTA.loginWithRedirect({
      authorizationParams: {
        connection: "VistraOktaWIAMTenantOIDC"
      }
    });

    this.ngxService.start();
  }

makeLoginCall() {

        // this.jqueryDialogService.showLoaderForSearchManagerCall = true;
        this.ngxService.stop()
        this.authService.resetAllLocalStorageData();
        this.authService.AccessToken = this.accessToken;
        this.authService.newTokenSet = false;
        this.authService.tokenProfileDataReadFromSessionStorage = false;
        this.authService.HasBeenOnceOpened = true;
        //this.getUserInfo();
        this.getConfigurationDataOfLoggedInUser();
    }

  getConfigurationDataOfLoggedInUser() {
    this.authService.setAuthentication(this.userProfile.UserId);

    this.loginProvider.getData('api/Configuration/GetLoggedInUserConfigurationData').subscribe(
      (posts) => {
        this.authService.UserType = posts.UserType;
        this.authService.UserName = posts.UserName;
        this.authService.UserClass = posts.UserClass;
        this.authService.RecordNum = posts.RecordNum;
        this.authService.WpUserNum = posts.WpUserNum;
        this.authService.accessTokenRemovedSubj.next(false);
        // Check if Security question fields are blank,  then navigate to set security question
        // if (posts.SetUpSecurityQuestion) {
        //   this.authService.navigateToUrl('set-security-question', {
        //     returnUrl: 'home',
        //     userNumber: this.userProfile.UserId
        //   });
        // } else {

          this.authService.navigateToUrl('home');
        // }
      },
      (error) => {
        this.display = true;
        if (error.status == 401) {
          this.alertMessage = 'Not Authorized';
          this.authService.resetAllLocalStorageData();
        }
        else {
          this.alertMessage = this.dictionaryPipe.transform('DEFAULT_ERROR'); // TODO: replace with error message from BE
        }
      }
    );
  }

  onConfirm(next: boolean) {
    this.display = false;
  }

}
